import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const navItems = [
  { to: "/", label: "Dashboard", icon: "📊" },
  { to: "/moderation", label: "Moderation Queue", icon: "🛡️" },
  { to: "/experiences", label: "Experiences", icon: "📝" },
  { to: "/company-suggestions", label: "Company Suggestions", icon: "💡" },
  { to: "/companies", label: "Companies", icon: "🏢" },
];

export function Sidebar() {
  const location = useLocation();
  const { user, signOut } = useAuth();

  return (
    <aside className="w-64 bg-surface-container-low border-r border-white/5 flex flex-col min-h-screen">
      <div className="p-stack-md border-b border-white/5">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="daftar.fyi" className="h-6 w-6" />
          <span className="font-headline-md text-headline-md text-on-surface font-bold">
            daftar.fyi
          </span>
        </Link>
        <span className="font-label-xs text-label-xs text-on-surface-variant">Admin Panel</span>
      </div>

      <nav className="flex-1 p-stack-sm">
        {navItems.map((item) => {
          const isActive =
            item.to === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg font-body-md text-body-md transition-colors mb-1 ${
                isActive
                  ? "bg-primary-container/20 text-primary"
                  : "text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface"
              }`}
            >
              <span aria-hidden="true">{item.icon}</span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="p-stack-md border-t border-white/5">
        <div className="font-label-xs text-label-xs text-on-surface-variant truncate mb-2">
          {user?.email}
        </div>
        <button
          onClick={signOut}
          className="w-full text-left px-3 py-2 rounded-lg font-body-md text-body-md text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface transition-colors"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
